module.exports = __webpack_public_path__ + "img/Comment.27f92b4d.svg";